import { useEffect, useState } from "react";
import { getUserLocalCacheByCurrentUser } from "@/actions/userLocalCacheActions";
import { UserLocalCache } from "@prisma/client";
import { useDecodedUserIdSession } from "./useDecodedUserIdSession";

export const useGetCurrentUser = () => {
  const userUuid = useDecodedUserIdSession();
  const [currentUser, setCurrentUser] = useState<UserLocalCache>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userUuid) return;

    const fetchUser = async () => {
      setLoading(true);
      const user = await getUserLocalCacheByCurrentUser();
      setLoading(false);

      if (user == null) {
        throw new Error("Current user not found in UserLocalCache.");
      }

      setCurrentUser(user);
    };

    fetchUser();
  }, [userUuid]);

  return {currentUser, loading};
};

export default useGetCurrentUser;
